module.exports = __webpack_public_path__ + "img/Kc.74c37185.png";